import Vue from 'vue'
import router from './router'
import store from '@/store'
import NProgress from 'nprogress' // progress bar
import { generateIndexRouter } from '@/util/'
import { ACCESS_TOKEN, INDEX_MAIN_PAGE_PATH } from '@/store/mutation-types'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/signIn']

function getQueryVariable(query, variable) {
	console.log('query', query)
	var vars = query.split('&')
	console.log(vars)
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=')
		if (pair[0] == variable) {
			return pair[1]
		}
	}
	return false
}

//强制要求使用KeepAlive状态的路由。
const keepAlives = ['_gmqm-defect-joborders', 'production_defect', '_gmqm-control-production', '_gmqm-check-craft', '_gmqm-workshop-board', '_gmqm-control-devices']
router.beforeEach((to, from, next) => {
	NProgress.start()

	//设置页面标题。
	if (to.meta.title) {
		document.title = to.meta.title
	}

	if (keepAlives.indexOf(to.name) > -1) to.meta.keepAlive = true

	console.log(to)

	if (Vue.ls.get(ACCESS_TOKEN)) {
		/* has token */
		if (to.path === '/signIn') {
			next({ path: 'index' })
			NProgress.done()
		} else {
			if (store.getters.permissionList.length === 0) {
				store
					.dispatch('GetPermissionList')
					.then(res => {
						const menuData = res.result.menu
						console.log(res)
						if (menuData === null || menuData === '' || menuData === undefined) {
							return
						}

						let constRoutes = []
						constRoutes = generateIndexRouter(menuData)

						console.log('constRoutes', constRoutes)

						//next()
						// 添加主界面路由
						store.dispatch('UpdateAppRouter', { constRoutes }).then(() => {
							console.log('根据roles权限生成可访问的路由表')

							// 根据roles权限生成可访问的路由表
							// 动态添加可访问路由表
							router.addRoutes(store.getters.addRouters)
							const redirect = decodeURIComponent(from.query.redirect || to.path)

							console.log('redirect', redirect)
							if (to.path === redirect && to.path != '/') {
								// hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
								console.log('to.path', to.path)

								next({ ...to, replace: true })
							} else {
								console.log('跳转到目的路由')
								// 跳转到目的路由
								next({ path: redirect })
							}
						})
					})
					.catch(() => {
						store.dispatch('Logout').then(() => {
							next({ path: '/signIn', query: { redirect: to.fullPath } })
						})
					})
			} else {
				next()
			}

			//next()
		}
	} else {
		console.log(to)
		var query = { redirect: to.fullPath }
		var redirect = to.fullPath
		if (to.query.redirect) {
			redirect = to.query.redirect
		}

		//检查参数中是否包含company
		var company = getQueryVariable(redirect, 'company')
		if (to.query.company) {
			company = ''
		}

		if (whiteList.indexOf(to.path) > -1) {
			// 在免登录白名单，直接进入
			console.log('在免登录白名单，直接进入，进入登陆界面')
			if (company) {
				console.log('包含company，取出company单独作为参数。', company, redirect)
				next({ path: to.path, query: { company, redirect } })
			} else {
				console.log('next')
				next()
			}

			NProgress.done()
		} else {
			// //如果是公有云环境，从本地session获取company参数，加到url。
			// if (process.env.VUE_APP_VERSION == 'public') {
			// 	query.company = sessionStorage.getItem('company')
			// 	query.factory = ''
			// }

			//如果URL带有参数，优先从URL读取。
			if (to.query.factory && to.query.company) {
				query.company = to.query.company
				query.factory = to.query.factory
			}

			next({ name: 'SignIn', query: query })
			NProgress.done()
		}
	}

	//next()
})

router.afterEach(() => {
	NProgress.done()
})
